import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '../icon/icon.module';
import { CheckboxGroupComponent } from './checkbox-group.component';
import { StackModule } from '../stack/stack.module';
import { TextModule } from '../text/text.module';
import { MessageModule } from '../message/message.module';

@NgModule({
  declarations: [CheckboxGroupComponent],
  imports: [CommonModule, IconModule, StackModule, TextModule, MessageModule],
  exports: [CheckboxGroupComponent],
})
export class CheckboxGroupModule {}
